import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { fileUrl } from "@/lib/api";
import { AuthorLink, AuthorAvatar } from "@/components/social/AuthorLink";

export function PublicQna({ targetType, targetId, ask = null }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    let ok = true;
    api.get(`/questions/public/${targetType}/${targetId}`)
      .then(({ data }) => { if (ok) setItems(data); }).catch(() => { if (ok) setItems([]); });
    return () => { ok = false; };
  }, [targetType, targetId]);

  if (!items) return null;
  // Without an "ask" affordance there's nothing to show when empty (e.g. profile pages).
  if (items.length === 0 && !ask) return null;
  return (
    <Card className="border-0 p-6" data-testid="public-qna">
      <h3 className="text-lg font-[640]">Questions &amp; Answers</h3>
      {ask && <div className="mt-3" data-testid="event-ask-card">{ask}</div>}
      {items.length === 0 ? (
        <p className="mt-3 text-sm text-muted-foreground">No questions yet. Be the first to ask.</p>
      ) : (
        <div className={`mt-4 space-y-5 ${items.length > 5 ? "max-h-[30rem] overflow-y-auto pr-2" : ""}`}>
          {items.map((q) => (
            <div key={q.id} className="border-b border-border pb-5 last:border-0 last:pb-0">
              <div className="flex items-start gap-3">
                <AuthorAvatar card={q.asker}>
                  <Avatar className="h-8 w-8">
                    {q.asker && q.asker.headshot_url && <AvatarImage src={fileUrl(q.asker.headshot_url)} alt="" />}
                    <AvatarFallback className="bg-secondary text-xs">{(q.asker && q.asker.display_name ? q.asker.display_name[0] : "?")}</AvatarFallback>
                  </Avatar>
                </AuthorAvatar>
                <div className="min-w-0 flex-1">
                  <p className="font-[560] text-foreground">{q.body}</p>
                  <p className="mt-0.5 text-xs text-muted-foreground">Asked by <AuthorLink card={q.asker} className="font-[560] text-foreground" fallback="a member" testId={`qna-asker-${q.id}`} /></p>
                  <div className="mt-2 rounded-lg border-l-2 border-l-primary bg-secondary/50 px-3 py-2 text-[14px] leading-7 text-foreground">{q.answer}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
